import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Perfil from './pages/Perfil';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Maquinas from './pages/Maquinas';
import Intervenciones from './pages/Intervenciones';
import Tareas from './pages/Tareas';
import Layout from './components/Layout';
import Usuarios from './pages/Usuarios';
import Almacen from './pages/Almacen';
import Administracion from './pages/Administracion';
import Academy from './pages/Academy';
import Comercial from './pages/Comercial';
import EstudiosOperacion from './pages/EstudiosOperacion';
import Enrolar2FA from './components/Enrolar2FA';
import Facturas from './pages/Facturas';
import ConfigERP from './pages/ConfigERP';
import Tesoreria from './pages/Tesoreria';
import Compras from './pages/Compras';
import Incidencias from './pages/Incidencias';

const isAuthenticated = () => !!localStorage.getItem('token');

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const [necesita2FA, setNecesita2FA] = React.useState(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return !!localStorage.getItem('token') && user.totp_activo === false;
  });

  if (!isAuthenticated()) return <Navigate to="/login" />;
  if (necesita2FA) return <Enrolar2FA onCompletado={() => setNecesita2FA(false)} />;
  return <>{children}</>;
};

function App() {
  return (
    <BrowserRouter basename="/app">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <PrivateRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/perfil" element={
          <PrivateRoute>
            <Layout>
              <Perfil />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/clientes" element={
          <PrivateRoute>
            <Layout>
              <Clientes />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/maquinas" element={
          <PrivateRoute>
            <Layout>
              <Maquinas />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/comercial" element={
          <PrivateRoute>
            <Layout>
              <Comercial />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/estudios" element={
          <PrivateRoute>
            <Layout>
              <EstudiosOperacion />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/intervenciones" element={
          <PrivateRoute>
            <Layout>
              <Intervenciones />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/tareas" element={
          <PrivateRoute>
            <Layout>
              <Tareas />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/usuarios" element={
          <PrivateRoute>
            <Layout>
              <Usuarios />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/almacen" element={
          <PrivateRoute>
            <Layout>
              <Almacen />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/administracion" element={
          <PrivateRoute>
            <Layout>
              <Administracion />
            </Layout>
          </PrivateRoute>
        } />
       <Route path="/academy" element={
          <PrivateRoute>
            <Layout>
              <Academy />
            </Layout>
          </PrivateRoute>
        } /> 
        <Route path="/facturas" element={
          <PrivateRoute>
            <Layout>
              <Facturas />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/config-erp" element={
          <PrivateRoute>
            <Layout>
              <ConfigERP />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/tesoreria" element={
          <PrivateRoute>
            <Layout>
              <Tesoreria />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/compras" element={
          <PrivateRoute>
            <Layout>
              <Compras />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/incidencias" element={
          <PrivateRoute>
            <Layout>
              <Incidencias />
            </Layout>
          </PrivateRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;